/**
 * Default number of items before the end of the items list to start loading the
 * next page of items.
 */
export const DEFAULT_PAGINATION_THRESHOLD = 6
